export default __webpack_public_path__ + "static/vid-9ac7e1ade3bdd2089a20e024857a5a5e.mp4";